import { FC } from "react";
import { useLocation } from "react-router-dom";
import { formatPrice } from "utils/convertNumbThousand";
import logoSrc from "images/bonzah.png";
export interface FleetCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  simpleImg?: boolean;
  onClick?: any;
}

const FleetCard: FC<FleetCardProps> = ({
  size = "default",
  className = "",
  data,
  simpleImg = false,
  onClick,
}) => {
  const {
    fleet_photos,
    name,
    color,
    seats,
    avg_car_price_per_day,
    thumbnail_photo_url,
    allowed_insurances,
  } = data!;
  const location = useLocation();

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        {/* Bonzah included badge when allowed_insurances contains specific ids */}
        {(function renderBonzahBadge() {
          const allowedInsuranceIds = [99991, 99992, 99993, 99994,99995];
          const list = allowed_insurances ?? data?.allowed_insurances ?? [];
          const hasBonzahInsurance = Array.isArray(list)
            ? // match when entry is the string "all" (case-insensitive) OR one of the allowed numeric ids (string or number)
              list.some((id: any) => {
                if (id === null || id === undefined) return false;
                const lowered = String(id).trim().toLowerCase();
                if (lowered === "all") return true;
                const n = Number(id);
                return !Number.isNaN(n) && allowedInsuranceIds.includes(n);
              })
            : false;
          if (!hasBonzahInsurance) return null;
          return (
            <div className="absolute top-2 left-2 z-10 flex items-center space-x-2 px-2 py-1 rounded-md bg-white bg-opacity-90 shadow">
              <img
                src={logoSrc}
                alt="Bonzah"
                className="w-5 h-5 object-contain"
                onError={(e: any) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <span className="text-xs font-semibold text-gray-700">Bonzah available</span>
            </div>
          );
        })()}
        {/* {simpleImg ? ( */}
        <img
          src={
            fleet_photos &&
            fleet_photos.length > 0 &&
            thumbnail_photo_url.includes("http")
              ? thumbnail_photo_url
              : fleet_photos && fleet_photos.length > 0
              ? `https://fleet-management-images-upload-be.s3.amazonaws.com/${encodeURIComponent(
                    thumbnail_photo_url,
                  )}`
              : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
          }
          alt="name"
          className="h-[200px] object-cover w-full"
        />
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <h2
              className={`font-medium capitalize w-full ${
                size === "default" ? "text-lg" : "text-base"
              }`}
            >
              <div
                className="max-w-full"
                style={{ width: "100%", maxWidth: "100%" }}
              >
                <span
                  className="block truncate text-text-color whitespace-nowrap overflow-hidden overflow-ellipsis"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {name}
                </span>
              </div>
            </h2>
          </div>

          <span className="text-text-color text-sm">
            <span className="font-semibold">{seats}</span> seats{" "}
            <span className="font-semibold">{color}</span> color
          </span>
        </div>
        <div className="w-14 border-b border-secondary-100 "></div>
        {avg_car_price_per_day !== 0 && (
          <div className="flex justify-between items-center">
            <span className="text-base font-semibold text-text-color">
              {"$" + formatPrice(avg_car_price_per_day ?? 0)}

              {` `}
              {size === "default" && (
                <span className="text-sm text-text-color font-normal">
                  /day
                </span>
              )}
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative rounded-md border border-secondary-100 overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}${
        location.pathname === "/available-car" ? "cursor-pointer" : ""
      }`}
      data-nc-id="StayCard"
      onClick={onClick}
    >
      {renderSliderGallery()}
      {renderContent()}
    </div>
  );
};

export default FleetCard;
